import { BrowserModule, Title }  from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
// import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

/*pdf*/
import { FormsModule } from '@angular/forms';
import { SimplePdfViewerModule } from 'simple-pdf-viewer';
/*imagegallery*/
import 'hammerjs';
import 'mousetrap';
import { ModalGalleryModule } from '@ks89/angular-modal-gallery';

import { PageService } from './page.service';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { HeaderComponent } from './header/header.component';
import { SectionComponent } from './section/section.component';
import { FooterComponent } from './footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { PageComponent } from './page/page.component';
import { HomeComponent } from './home/home.component';
import { MenuChildsComponent } from './menu-childs/menu-childs.component';
import { InterviewComponent } from './interview/interview.component';
import { InterviewGridComponent } from './interview-grid/interview-grid.component';
import { DedaloService } from './dedalo.service';
import { HideMarkers } from './pipe';
import { TextComponent } from './text/text.component';


@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    HeaderComponent,
    SectionComponent,
    FooterComponent,
    PageComponent,
    HomeComponent,
    MenuChildsComponent,
    InterviewComponent,
    InterviewGridComponent,
    HideMarkers,
    TextComponent,
  ],
  imports: [
    BrowserModule,
    // HttpModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    SimplePdfViewerModule,
    ModalGalleryModule.forRoot()
  ],
  providers: [
    PageService,
    DedaloService,
    Title,
    //{provide: LOCALE_ID, useValue: 'es-ES'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

/* otros ejemplos */
/*
https://github.com/Ks89/angular-modal-gallery
https://github.com/viktorhajer/simple-pdf-viewer/wiki/API-Documentation
*/
